import React from 'react'
import styled from '@emotion/styled'

const StyledButtonList = styled.ul`
  margin: 0;
  padding: 0;

  > li {
    list-style: none;
  }

  > li + li {
    margin-top: 0.5rem;
  }
`

export const ButtonList: React.FC = ({ children }) => (
  <StyledButtonList>
    {React.Children.map(children, (child) => (
      <li>{child}</li>
    ))}
  </StyledButtonList>
)
